module.exports = __webpack_public_path__ + "c3340ea7d5f39694a749838d2b2b79fc.svg";